const RequestID = require("shortid")

RequestID.seed(101714)
RequestID.characters(
  "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$#"
)

export default RequestID
